import lod_ from "lodash";
import { Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { useLanguages } from "hooks/useLanguages";

/**
 * Languages Cell component for displaying language counts
 * @param {Object} row - Row data object
 * @returns {JSX.Element} MDBox with language count
 */
const LanguagesCell = ({ row, isSelected }) => {
	const { languages } = useLanguages();

	const values = row.original;
	const allLanguagesObject = (values?.content ?? [])[0] ?? {};

	const filterFunction = ([key, value]) => {
		if (lod_.isNil(value)) {
			return false;
		}

		if (!lod_.isNil(value.text) && !lod_.isEmpty(value.text.trim())) {
			return true;
		}

		if (
			!lod_.isNil(value.question) &&
			!lod_.isNil(value.answer) &&
			!lod_.isEmpty(value.question.trim()) &&
			!lod_.isEmpty(value.answer.trim())
		) {
			return true;
		}

		return false;
	};

	const notEmptyLanguages = Object.entries(allLanguagesObject)
		.filter(filterFunction)
		.map(([key, value]) => ({ code: key }));

	const notEmptyLanguagesCount = notEmptyLanguages.length;

	const usedLanguages = languages.filter(lang => {
		return notEmptyLanguages.some(langObj => langObj.code === lang.code);
	});

	return (
		<MDBox>
			<Tooltip
				placement="right"
				arrow
				title={
					<MDBox>
						{usedLanguages.map(lang => (
							<MDBox display="flex" alignItems="center" key={lang.code}>
								<img
									src={lang.logoURL}
									alt={lang.code}
									style={{
										width: "20px",
										height: "20px",
										borderRadius: "50%",
										marginRight: "10px"
									}}
								/>
								<MDTypography
									key={lang.code}
									variant="body2"
									color="white"
									fontWeight="bold"
									fontSize="small"
								>
									{lang.name}
								</MDTypography>
							</MDBox>
						))}
					</MDBox>
				}
			>
				<MDTypography
					variant="body2"
					color={isSelected ? "white" : "text"}
					fontWeight={isSelected ? "bold" : "normal"}
					fontSize="small"
				>
					{`${notEmptyLanguagesCount} / ${languages?.length ?? 0}`}
				</MDTypography>
			</Tooltip>
		</MDBox>
	);
};

export default LanguagesCell;
